import {Select, FormGroup, Paper, TextField, Typography, FormControl, Switch, FormControlLabel, InputLabel, Button, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";

import { useAppData } from "./appDataContext.js";
import { fetchTaskbyId, updateTask, fetchEmployees, fetchDest, gmailSend} from "../api/customerapi";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const UpdateTask = () => {

    const classes = useStyles();
   const { cuser, role, employeelist, destinationlist, loading } = GetRole();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [taskData, settaskData] =useState({
        task_status:"",
        task_description:"",
        task_destination:"",
        task_response:"",
        task_category:"",
        assigned_to:"",
        assigned_by:"",
        deadline_date:"",
        deadline_time:"",
        task_priority:"",
        ticket_category:"L1",
        root_cause:"",
    });
    // const [tData, settData]=useState(null);
    const [oldtaskstatus, setoldtaskstatus]=useState("")
    const [emp, setemp]=useState([])
    const [rm, setrm]=useState(false)
    const [dest, setdest]=useState([])
    const [emplist, setemplist]=useState([])
    var fupsomeDate = new Date();
 // const { appData, loading } = useAppData();
    fupsomeDate.setDate(fupsomeDate.getDate()); 
  const fupy=fupsomeDate.getFullYear()
  const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
  const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
  const fupfinalDate=(fupy+"-"+fupm+"-"+fupdt)

    const getEmployees = async () => {
      try{
        // var data=await fetchEmployees()
        setemplist(employeelist)
        const empsplist = employeelist.filter((emp) => !(emp.role == "Ex-employee" || emp.role == "Sales"  || emp.role == "Marketing" || emp.role == "Sales Support"));
        //const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
        var empshortname = empsplist.map((emp) => emp.short_name);
        if(empshortname.length==0){
          empshortname=["Amit"]
        }
        setemp(empshortname);
        var temp=employeelist.filter(e=>e.short_name==cuser)
        var temp2=temp[0].reporting_manager
        setrm(temp2)
      }catch(err){
        console.log(err)
      }
      };

      const getTask = async (currentid) => {
        try{
        var data=await fetchTaskbyId(currentid)
        console.log(data.data)
        setoldtaskstatus(data.data.task_status)
        // if(data.data && "task_status" in data.data && data.data.task_status ){
        // console.log(data.data.task_status)
        // setoldtaskstatus(data.data.task_status)
        // 
        // }
        settaskData(data.data)
        
      }catch(err){
        console.log(err)
      }
      };
      //console.log(taskData)
      const getrecepient = (person, person2) => { 
        const temp=emplist.filter(data=>data.short_name==person)
        const temp2=emplist.filter(data=>data.short_name==person2)
        const role=temp[0].role
        if(role=="Sales" || role=="SME"){
          return [temp[0].email, temp2[0].email, "abhishek.sharma@jetovacations.com"]
        }else if(role=="Operations"){
          return [temp[0].email, temp2[0].email, "operations@jetovacations.com"]
        }else if(role=="Product"){
          return [temp[0].email, temp2[0].email, "product1@jetovacations.com"]
        }else{
          return [temp[0].email, temp2[0].email]
        }
      }

      const getDest = async () => {
        try{
        //const data = await fetchDest();
        const temp=destinationlist.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      }
 
      const reminder=async()=>{
        var mailtemp=emplist.filter(data=>data.short_name==taskData.assigned_to)
        var mailtemp2=emplist.filter(data=>data.short_name==taskData.assigned_by)
               
               
                  let from="care@jetovacations.com"
                  let to=[mailtemp[0].email, "abhishek.sharma@jetovacations.com", mailtemp2[0].email]
                  let subject="Reminder to resolve task id: "+taskData.task_id
                  let body=`<p>Kindly update on task id: ${taskData.task_id}</p>`
                  const data=await gmailSend(from, to, subject, body)
                  alert(data.data)
      }

    useEffect(() => {
      if(!loading){
        getEmployees()
        getDest()
        getTask(currentid)
      }
        
    }, [cuser, role, employeelist, destinationlist, loading])

    const getTeam=(emp)=>{
  const x=emplist.filter(e=>e.short_name==emp)
  return x && x.length>0 && "role" in x[0]?x[0].role:""
}
    
    //console.log(custdatalistfromdb);
    //const updatedName= useSelector((state)=> currentID ? (state.reducerNames.find((p) => p._id ===currentID)) : null);

    const handleSubmit =async (e) => {
      try{
        e.preventDefault();
        var closedate="closedAt" in taskData?taskData.closedAt:null
        var tddate="task_done_date" in taskData?taskData.task_done_date:null
        var closedby=null
        var sh=[]
        if(oldtaskstatus!==taskData.task_status){
          var temp={
            status:taskData.task_status,
            status_date:new Date()
          }
          sh=[...taskData.status_history, temp]
        }
        if(oldtaskstatus && oldtaskstatus!=="Close" && taskData.task_status=="Close"){
          closedate= new Date()
          closedby=cuser
        }
        if(oldtaskstatus && oldtaskstatus!=="Task Done" && taskData.task_status=="Task Done"){
          tddate= new Date()
        }
        const finaltaskData={...taskData, updatedAt:new Date(), closedAt:closedate, task_done_date:tddate, status_history:sh, closed_by:closedby}
        console.log(finaltaskData);
        const updatetaskResponse= await updateTask(finaltaskData);
       
        
        if(updatetaskResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            //alert(updatetaskResponse.data)
            alert("Ticket updated with task id "+updatetaskResponse.data.task_id);
            var from="care@jetovacations.com"
            var subject="Change in task id "+updatetaskResponse.data.task_id+" - "+updatetaskResponse.data.task_status
            var body="Ticket updated "
            var to=getrecepient(taskData.assigned_to, taskData.assigned_by)
            console.log(to)
            let receiptmail= await gmailSend(from, to, subject, body)
            alert(receiptmail.data)
            window.location = ("/taskdataentry/"+updatetaskResponse.data.task_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      }catch(err){
        console.log(err)
      } 
    }

    const wrongtickeupdate=(e)=>{
      settaskData({...taskData, wrong_ticket:e.target.checked})
      if(e.target.checked){
        let r=window.prompt("Mention reason:")
        if(r){
          settaskData({...taskData, wrong_ticket_reason:r})
        }
      }
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="right">
         <Button
                  onClick={reminder}
                  variant="contained"
                  color="primary"
                  className={classes.smallbutton}
                >
                  <h6>Send Reminder</h6>
                </Button>
                 <FormControlLabel control={<Switch checked={"private_task" in taskData?taskData.private_task:false} color="secondary" onChange={(e)=>settaskData({...taskData, private_task:e.target.checked})}/>}  label="Private Task?" />
                 
                 <FormControlLabel control={<Switch checked={"wrong_ticket" in taskData?taskData.wrong_ticket:false} color="secondary" disabled={cuser==taskData.assigned_to?0:1} onChange={(e)=>wrongtickeupdate(e)}/>}  label="Wrong Ticket?" />
                </div>
                 <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Wrong Reason"  InputLabelProps={{ shrink: true }} value={taskData.wrong_ticket_reason} className={classes.textField}  disabled/>
                </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> Update Ticket</Typography>
            
            <Typography variant="h6" align="center" className={classes.headertext}>Created At: {"createdAt" in taskData?new Date(taskData.createdAt).toLocaleString("en-IN"):""} || {taskData.task_status=="Close" && "closedAt" in taskData?"Closed At:"+new Date(taskData.closedAt).toLocaleString("en-IN"):"Time since creation: "+((new Date().getTime()-new Date(taskData.createdAt).getTime())/(1000*60*60)).toFixed(1)}</Typography>
            <form onSubmit={handleSubmit}>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Description"  InputLabelProps={{ shrink: true }} value={taskData.task_description} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> settaskData({...taskData, task_description: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Response"  InputLabelProps={{ shrink: true }} value={"task_response" in taskData?taskData.task_response:""} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> settaskData({...taskData, task_response: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="task owner">Assign To:</InputLabel>
                <Select className={classes.textField} labelId="Ticket Owner" required value={taskData.assigned_to} onChange={(e)=> settaskData({...taskData, assigned_to: e.target.value})}>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}    
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Trip Id"   value={taskData.trip_id}
                              
                                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, trip_id: e.target.value.trim()})}/>
                <TextField variant="standard"  type="date" label="Deadline Date"   inputProps={{ min: fupfinalDate }} 
                              
                                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, deadline_date: e.target.value})}/>
                <TextField variant="standard"  type="date" label="Deadline Date"  disabled={cuser==taskData.assigned_by?0:1}
                value={taskData.deadline_date}
                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, deadline_date: e.target.value})}/>
                <TextField variant="standard"  type="time" label="Deadline Time"   disabled={cuser==taskData.assigned_by?0:1}
                value={taskData.deadline_time}
                className={classes.textField2} InputLabelProps={{ shrink: true }} onChange={(e)=> settaskData({...taskData, deadline_time: e.target.value})} />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
           
                <TextField variant="standard"  label="Assigned By"   disabled value={taskData.assigned_by}
                className={classes.textField} InputLabelProps={{ shrink: true }} />
                 <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="priority">Priority</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="priority" value={taskData.task_priority} onChange={(e)=> settaskData({...taskData, task_priority: e.target.value})}>
                <MenuItem value={"P1"}>P1</MenuItem>;
                <MenuItem value={"P2"}>P2</MenuItem>;
                <MenuItem value={"P3"}>P3</MenuItem>;
                </Select>
                </FormControl>
                {role=="Operations" || role=="Support"  || role=="Admin" || role=="Accounts" || role=="Product" || role=="Operations-TL" || (cuser && role!=="Sales" && "assigned_by" in taskData && cuser==taskData.assigned_by) || (cuser && role!=="Sales" && "assigned_by" in taskData && getTeam(cuser)==getTeam(taskData.assigned_by))  || (cuser && "assigned_by" in taskData && rm && cuser==rm) || (role=="Sales" && cuser && "assigned_by" in taskData && cuser==taskData.assigned_by)?(
                  
                  <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="status" required value={"task_status" in taskData && taskData.task_status?taskData.task_status:""} onChange={(e)=> settaskData({...taskData, task_status: e.target.value})}>
                <MenuItem value={"Open"}>Open</MenuItem>;
                <MenuItem value={"In Progress"}>In Progress</MenuItem>;
                {taskData && (taskData.task_status=="Task Done" || taskData.task_status=="Close")?(<MenuItem value={"Close"}>Close</MenuItem>):("")}
                <MenuItem value={"Waiting"}>Waiting</MenuItem>;
                <MenuItem value={"Task Done"}>Task Done</MenuItem>;
                <MenuItem value={"Back to Owner"}>Back to Owner</MenuItem>;
                </Select>
                </FormControl>):(
                  <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="status" required value={"task_status" in taskData && taskData.task_status?taskData.task_status:""} onChange={(e)=> settaskData({...taskData, task_status: e.target.value})}>
                <MenuItem value={"Open"}>Open</MenuItem>;
                <MenuItem value={"Waiting"}>Waiting</MenuItem>;
                <MenuItem value={"Task Done"}>Task Done</MenuItem>;
                </Select>
                </FormControl>
                )}
                {role=="Sales" || role=="SME"?(<FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="status" required value={"task_status" in taskData && taskData.task_status?taskData.task_status:""} onChange={(e)=> settaskData({...taskData, task_status: e.target.value})}>
                <MenuItem value={"Open"}>Open</MenuItem>;
                <MenuItem value={"Task Done"}>Task Done</MenuItem>;
                <MenuItem value={"Waiting"}>Waiting</MenuItem>;
                </Select>
                </FormControl>):("")}
                
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="category">Category</InputLabel>
                <Select displayEmpty disabled={cuser==taskData.assigned_by?0:1} className={classes.textField} labelId="category" value={taskData.task_category} onChange={(e)=> settaskData({...taskData, task_category: e.target.value})}>
                <MenuItem value={"Rate Query"}>Rate Query</MenuItem>;
                <MenuItem value={"Data updation request"}>Data updation request</MenuItem>;
                <MenuItem value={"Information Query"}>Information Query</MenuItem>;
                <MenuItem value={"Asking for documents"}>Asking for documents</MenuItem>;
                <MenuItem value={"Customer Support"}>Customer Support</MenuItem>;
                <MenuItem value={"Rate Increase"}>Rate Increase</MenuItem>;
                <MenuItem value={"Package not final"}>Package not final</MenuItem>;
                <MenuItem value={"Customer asked for changes"}>Customer asked for changes</MenuItem>;
                <MenuItem value={"Book Hotel Online"}>Book Hotel Online</MenuItem>;
                <MenuItem value={"Book Hotel Offline"}>Book Hotel Offline</MenuItem>;
                <MenuItem value={"Hold Ops"}>Hold Ops</MenuItem>;
                <MenuItem value={"Refund"}>Refund</MenuItem>;
                <MenuItem value={"Briefing Call"}>Briefing Call</MenuItem>;
                <MenuItem value={"Others"}>Others</MenuItem>;
                </Select>
                </FormControl>
                {taskData.task_category=="Rate Query"?(
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={taskData.task_destination} onChange={(e)=> settaskData({...taskData, task_destination: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Bali"}>Bali</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                ):("")}
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="tickettype">Ticket Type</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="tickettype" value={"ticket_category" in taskData?taskData.ticket_category:""} onChange={(e)=> settaskData({...taskData, ticket_category: e.target.value})}>
                <MenuItem value={"L1"}>L1</MenuItem>;
                <MenuItem value={"L2"}>L2</MenuItem>;
                <MenuItem value={"L3"}>L3</MenuItem>;
                <MenuItem value={"L4"}>L4</MenuItem>;
           
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="rcacat">RCA Category</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="rcacat" value={"rca_category" in taskData?taskData.rca_category:""} onChange={(e)=> settaskData({...taskData, rca_category: e.target.value})}>
                <MenuItem value={"Vendor Fault"}>Vendor Fault</MenuItem>;
                <MenuItem value={"Expectation Mismatch"}>Expectation Mismatch</MenuItem>;
                <MenuItem value={"Unreasonable Demand"}>Unreasonable Demand</MenuItem>;
                <MenuItem value={"Wrong Commitment"}>Wrong Commitment</MenuItem>;
                <MenuItem value={"Sold Out/Price Increase"}>Sold Out/Price Increase</MenuItem>;
                <MenuItem value={"Others"}>Others</MenuItem>;
                </Select>
                </FormControl>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Root Cause"  value={taskData.root_cause} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> settaskData({...taskData, root_cause: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default UpdateTask;